import { createTheme } from "@mui/material/styles";

export const customTheme = ({ darkMode }: { darkMode: boolean }) =>
  createTheme({
    typography: {
      fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,
    },
    palette: {
      mode: darkMode ? "dark" : "light",
      ...(darkMode
        ? {
            primary: {
              main: "#382053",
            },
            secondary: {
              main: "#CEB0FA",
            },
            scopelyBlue: {
              main: "#0c2aa9",
              light: "#0f35d6",
            },
          }
        : {
            primary: {
              main: "#382053",
            },
            secondary: {
              main: "#CEB0FA",
            },
            scopelyBlue: {
              main: "#0c2aa9",
              light: "#0f35d6",
            },
          }),
    },

    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1250,
        xl: 1536,
      },
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: () => ({
          img: {
            maxWidth: "100%",
            height: "auto",
          },
        }),
      },
      MuiButton: {
        variants: [
          {
            props: { color: "secondary" },
            style: {
              padding: "12px 16px",
              color: "#360083",
              border: "1px solid #CEB0FA",
              background: "#EFE6FD",
            },
          },
        ],
        styleOverrides: {
          root: {
            fontSize: "16px",
            lineHeight: "16px",
            padding: "12px 16px",
            boxShadow: "none",
            gap: "0.5rem",
            textTransform: "none",
            "&:hover": {
              boxShadow: "none",
            },
            transition: "0.2s",
            color: "#EFE6FD",
            borderRadius: "8px",
          },
          startIcon: {
            margin: 0,
          },
        },
        defaultProps: {
          variant: "contained",
        },
      },
      MuiTextField: {
        defaultProps: {
          // The props to change the default for.
          variant: "outlined",
          size: "small",
        },
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderRadius: "8px",
              },
            },
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            width: "100%",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          root: {
            ".MuiPaper-root": {
              borderRadius: "24px",
              boxShadow: "none",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "24px",
            boxShadow: "none",
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
            display: "flex",
            gap: "8px",
            height: "40px",
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#382053",
            padding: "12px 16px",

            "&.Mui-selected": {
              backgroundColor: "#382053",
              color: "white",
              fontWeight: "700",

              "&:hover": {
                color: "#360083",
                border: "1px solid #CEB0FA",
                background: "#EFE6FD",
              },
            },
            "&:hover": {
              color: "#360083",
              border: "1px solid #CEB0FA",
              background: "#EFE6FD",
              padding: "11px 15px",
            },
          },
        },
      },
      MuiSkeleton: {
        styleOverrides: {
          root: {
            background: "#ffffff29",
          },
        },
      },
    },
  });
